var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentoring(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 17.6941V18.3881H5.89673V17.6941C5.89673 15.077 5.89673 13.7684 6.70977 12.9554C7.52281 12.1423 8.83137 12.1423 11.4485 12.1423C14.0656 12.1423 15.3742 12.1423 16.1872 12.9554C17.0003 13.7684 17.0003 15.077 17.0003 17.6941Z",
    fill: "url(#paint0_linear_5215_13713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2244 22.5519L17.0003 30.8796H5.89673L3.12085 22.5519H14.2244Z",
    fill: "url(#paint1_linear_5215_13713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.94 21.164C25.4731 21.164 26.7159 19.9212 26.7159 18.3881C26.7159 16.855 25.4731 15.6122 23.94 15.6122C22.4069 15.6122 21.1641 16.855 21.1641 18.3881C21.1641 19.9212 22.4069 21.164 23.94 21.164Z",
    fill: "url(#paint2_linear_5215_13713)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6316 5.89643C7.6316 3.78845 9.34046 2.07959 11.4484 2.07959C13.5564 2.07959 15.2653 3.78845 15.2653 5.89643C15.2653 8.00442 13.5564 9.71327 11.4484 9.71327C9.34046 9.71327 7.6316 8.00442 7.6316 5.89643ZM11.4484 4.1615C10.4903 4.1615 9.71352 4.93826 9.71352 5.89643C9.71352 6.85461 10.4903 7.63136 11.4484 7.63136C12.4066 7.63136 13.1834 6.85461 13.1834 5.89643C13.1834 4.93826 12.4066 4.1615 11.4484 4.1615Z",
    fill: "url(#paint3_linear_5215_13713)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3763 11.1012H11.5206C12.7676 11.1012 13.8075 11.1011 14.6331 11.2121C15.5044 11.3293 16.2911 11.587 16.9232 12.2191C17.5554 12.8513 17.8131 13.638 17.9303 14.5093C18.0413 15.3349 18.0412 16.3747 18.0412 17.6217L18.0412 18.3879C18.0412 18.9628 17.5751 19.4289 17.0002 19.4289C16.4253 19.4289 15.9593 18.9628 15.9593 18.3879V17.6939C15.9593 16.356 15.9571 15.4572 15.8669 14.7868C15.7808 14.1463 15.632 13.8722 15.4511 13.6913C15.2702 13.5104 14.9961 13.3616 14.3556 13.2755C13.6852 13.1853 12.7864 13.1831 11.4484 13.1831C10.1105 13.1831 9.21168 13.1853 8.54125 13.2755C7.90077 13.3616 7.62666 13.5104 7.44578 13.6913C7.26491 13.8722 7.11609 14.1463 7.02998 14.7868C6.93985 15.4572 6.93764 16.356 6.93764 17.6939V18.3879C6.93764 18.9628 6.47158 19.4289 5.89668 19.4289C5.32177 19.4289 4.85572 18.9628 4.85572 18.3879L4.85572 17.6218C4.85568 16.3747 4.85565 15.3349 4.96663 14.5093C5.08378 13.638 5.34148 12.8513 5.97365 12.2191C6.60582 11.587 7.3925 11.3293 8.26384 11.2121C9.08936 11.1011 10.1292 11.1012 11.3763 11.1012Z",
    fill: "url(#paint4_linear_5215_13713)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27633 21.9431C2.47198 21.6716 2.78619 21.5108 3.1208 21.5108H14.2243C14.6724 21.5108 15.0702 21.7975 15.2119 22.2226L17.7505 29.8384H22.552C23.1269 29.8384 23.5929 30.3045 23.5929 30.8794C23.5929 31.4543 23.1269 31.9204 22.552 31.9204H5.89668C5.44862 31.9204 5.05083 31.6336 4.90915 31.2086L2.13326 22.8809C2.02745 22.5635 2.08068 22.2145 2.27633 21.9431ZM15.556 29.8384L13.4741 23.5927H4.56505L6.64696 29.8384H15.556Z",
    fill: "url(#paint5_linear_5215_13713)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9399 14.5711C21.8319 14.5711 20.1231 16.2799 20.1231 18.3879C20.1231 20.4959 21.8319 22.2048 23.9399 22.2048C26.0479 22.2048 27.7568 20.4959 27.7568 18.3879C27.7568 16.2799 26.0479 14.5711 23.9399 14.5711ZM22.205 18.3879C22.205 17.4297 22.9818 16.653 23.9399 16.653C24.8981 16.653 25.6749 17.4297 25.6749 18.3879C25.6749 19.3461 24.8981 20.1228 23.9399 20.1228C22.9818 20.1228 22.205 19.3461 22.205 18.3879Z",
    fill: "url(#paint6_linear_5215_13713)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7761 23.5927C19.2012 23.5927 18.7351 24.0588 18.7351 24.6337C18.7351 25.2086 19.2012 25.6746 19.7761 25.6746H28.1038C29.0619 25.6746 29.8387 26.4514 29.8387 27.4095V28.1035C29.8387 29.0617 29.0619 29.8384 28.1038 29.8384H26.7158C26.1409 29.8384 25.6749 30.3045 25.6749 30.8794C25.6749 31.4543 26.1409 31.9204 26.7158 31.9204H28.1038C30.2117 31.9204 31.9206 30.2115 31.9206 28.1035V27.4095C31.9206 25.3016 30.2117 23.5927 28.1038 23.5927H19.7761Z",
    fill: "url(#paint7_linear_5215_13713)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5215_13713",
    x1: 14.9184,
    y1: 12.1423,
    x2: 14.9184,
    y2: 30.8796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5215_13713",
    x1: 14.9184,
    y1: 12.1423,
    x2: 14.9184,
    y2: 30.8796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5215_13713",
    x1: 14.9184,
    y1: 12.1423,
    x2: 14.9184,
    y2: 30.8796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5215_13713",
    x1: 17.0002,
    y1: 2.07959,
    x2: 17.0002,
    y2: 31.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5215_13713",
    x1: 17.0002,
    y1: 2.07959,
    x2: 17.0002,
    y2: 31.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5215_13713",
    x1: 17.0002,
    y1: 2.07959,
    x2: 17.0002,
    y2: 31.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5215_13713",
    x1: 17.0002,
    y1: 2.07959,
    x2: 17.0002,
    y2: 31.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5215_13713",
    x1: 17.0002,
    y1: 2.07959,
    x2: 17.0002,
    y2: 31.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentoring);
export default __webpack_public_path__ + "static/media/mentoring.4c6dcc6d30860b167652fb042a03978f.svg";
export { ForwardRef as ReactComponent };